import React, { useState } from "react";
import Typography from "@visa/vds/typography";
import MCSReadonlyField from "../MCSReadonlyField";
import SubscriptionStatusBadge from "./SubscriptionStatusBadge";
import SubscriptionFeeField from "./SubscriptionFeeField";
import SubscriptionFeeWaiverField from "./SubscriptionFeeWaiverField";
import { PRODUCT_CATEGORY, SubscriptionStatus } from "_constants/SubscriptionConstants";
import { DateHelper } from "_helpers/DateHelper";
import { Icon, Row } from "@visa/vds";
import EditVstsSubscriptionStartDateDialog from "./EditVstsSubscriptionStartDateDialog";
import { trackPromise } from "react-promise-tracker";
import { SubscriptionApi } from "services/subscription.service";
import { useAuthContextUser } from "context/AuthContext";

const SubscriptionInformationList = (props) => {
    const subscription = props.subscription;
    const isCancelled = subscription.subscriptionStatus === SubscriptionStatus.Cancelled;
    const showEndDate = subscription.productCategoryId === PRODUCT_CATEGORY.VSTS
        || (subscription.productCategoryId === PRODUCT_CATEGORY.VSTT && isCancelled);

    const [openEditVstsSubscriptionDialog, setOpenEditVstsSubscriptionDialog] = useState(false);
    const [latestNonFutureSubscriptionEndDate, setLatestNonFutureSubscriptionEndDate] = useState(null);
    const user = useAuthContextUser();
 
    const handleEditSubscriptionStartDateIconClick = () => {
        trackPromise(
            SubscriptionApi.GetCurrentVstsActiveSubscription()
                .then(result => {
                    if (typeof result == 'object') {
                        let date = new Date(result.endDate)
                        date.setDate(date.getDate())
                        setLatestNonFutureSubscriptionEndDate(date);
                    }
                    setOpenEditVstsSubscriptionDialog(true);
                })
                .catch(error => {})
            )
    }

    return (
        <>
            <EditVstsSubscriptionStartDateDialog
                setOpenEditVstsSubscriptionDialog={setOpenEditVstsSubscriptionDialog}
                openEditVstsSubscriptionDialog={openEditVstsSubscriptionDialog}
                subscription={subscription}
                latestNonFutureSubscriptionEndDate={latestNonFutureSubscriptionEndDate}
                fetchData={props.fetchData}
            />
            <Typography tag="h1">Subscription Information</Typography>
            <MCSReadonlyField label="Product Name" text={subscription.productName} />
            <MCSReadonlyField label="Subscription Name" text={subscription.subscriptionName} />
            <SubscriptionFeeField subscriptionType={subscription.subscriptionType} recurringType={subscription.recurringType} amount={subscription.amountString} />
            {subscription.hasFeeWaiver &&
                <SubscriptionFeeWaiverField amount={subscription.amount} feeWaiverPercentage={subscription.feeWaiverPercentage} />
            }
            <MCSReadonlyField label="Status" text={<SubscriptionStatusBadge startDate={subscription.startDate} status={subscription.subscriptionStatus} statusName={subscription.subscriptionStatusName} />} />
            <Row>
                <MCSReadonlyField label="Subscription Start Date" text={DateHelper.ToFormattedDate(subscription.startDate)} />
                {subscription.productName === "VISA SECURE TEST SUITE" && (new Date(subscription.startDate) > new Date()) && user.isExternalUser && 
                    <Icon name="edit"
                        resolution="low"
                        aria-label="edit"
                        style={{ marginLeft: "10px", cursor: "pointer", width: "20px", height: "20px" }}
                        onClick={handleEditSubscriptionStartDateIconClick}
                    />}
            </Row>
            {showEndDate &&
                <MCSReadonlyField label="Subscription Last Date" text={DateHelper.ToFormattedDate(subscription.endDate)} />
            }

        </>
    );
};

export default SubscriptionInformationList;
